import { inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { map, tap } from 'rxjs/operators';
import {
  BACK,
  FORWARD,
  GO,
  Go,
  UPDATE_QUERY_PARAMS,
  UpdateQueryParams
} from './router.actions';

@Injectable()
export class RouterEffects {
  private actions$ = inject(Actions);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private location = inject(Location);

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GO),
        map((action: Go) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
          void this.router.navigate(path, { queryParams, ...extras });
        })
      ),
    { dispatch: false }
  );

  updateQueryParams$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UPDATE_QUERY_PARAMS),
        map((action: UpdateQueryParams) => action.params),
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        tap(queryParams =>
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams,
            queryParamsHandling: 'merge'
          })
        )
      ),
    { dispatch: false }
  );

  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(BACK),
        tap(() => {
          this.location.back();
        })
      ),
    { dispatch: false }
  );

  navigateForward$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(FORWARD),
        tap(() => this.location.forward())
      ),
    { dispatch: false }
  );
}
